<template>
  <div class="row">
    <model-index
      ref="table"
      class="col-12"
      :loading="loading"
      v-bind="$props"
      :columns="columns"
      :busy.sync="busy"
      :models-paginated="modelsPaginated"
      :models="models"
      :page.sync="page"
      :per-page.sync="perPage"
      :from="from"
      :total="totalFiltered"
      :search.sync="search"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :empty-state-title="$t('sale_notes.empty_state.title')"
      empty-state-subtitle=" "
      @create-click="handleCreate"
      @show-click="handleShow"
      @edit-click="handleEdit"
      @delete-click="handleDelete"
    >
    </model-index>
  </div>
</template>

<script>
import ModelChildIndex from "../../models/children/index";

export default {
  extends: ModelChildIndex,
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("sale_notes.plural"));
      }
    },
    resourceRoute: { default: "sale_notes" },
    modelVariable: { default: "sale_note" },
    tableMinHeight: { type: Number, default: 85.5 }, // 42.5 + 43
    tableHeight: { type: Number, default: 214.5 }, // 42.5 + (43 * 4)
    denyCreate: { type: Boolean, default: true },
    hideTableHeader: { type: Boolean, default: true },
    parentFilterKey: { type: String, default: "sales_plan_id__in" },
    values: {
      type: Array,
      default() {
        return [];
      }
    },
    showProps: {
      default() {
        return {
          cardTitle: this.lodash.startCase(this.$t("sale_notes.singular")),
          resourceRoute: "sale_notes",
          modelVariable: "sale_note",
          denyEdit: true,
          denyDelete: true
        };
      }
    }
  },
  data() {
    return {
      sortBy: "id",
      sortDesc: true
    };
  },
  computed: {
    columns() {
      return {
        ["sale_note"]: [
          {
            key: "id",
            label: this.lodash.startCase(this.$t(`sale_notes.id`)),
            thStyle: { minWidth: "150px" },
            component: {
              props: ["item"],
              computed: {
                customLabel() {
                  return `${this.item.type_name}-${this.item.id}`;
                }
              },
              template: '<router-link :to="`/sale_notes/${item.id}`">{{ customLabel }}</router-link>'
            }
          },
          {
            key: "sale_item_total_quantity",
            label: this.lodash.startCase(this.$t(`sale_notes.sales_quantity`)),
            thClass: "text-end",
            tdClass: "text-end",
            thStyle: { minWidth: "100px" },
            formatter: value =>
                value >= 500
                    ? `${this.$numeral(value / 1000).format("0,0.[000]")} ${this.$t("units.ton")}`
                    : `${this.$numeral(value).format("0,0.[000]")} ${this.$t("units.kg")}`
          },
          {
            key: "total",
            label: this.lodash.startCase(this.$t(`sale_notes.sales_total`)),
            thClass: "text-end",
            tdClass: "text-end",
            thStyle: { minWidth: "150px" },
            formatter: value => this.$numeral(value).format("$ 0,0.[000]")
          },
          {
            key: "ordered_at",
            label: this.lodash.startCase(this.$t(`sale_notes.sales_ordered_at`)),
            formatter: value => (value ? this.$moment(value).format("DD MMM YYYY") : "-")
          },
          {
            key: 'odoo_sale_order.state',
            label: this.lodash.startCase(this.$t("sale_notes.odoo_sale_orders.state")),
            component: {
              props: ["item"],
              computed: {
                translatedState() {
                  let state = this.item.odoo_sale_order?.state
                  if (!state) {
                    return '-'
                  }
                  return this.$t(`sale_notes.odoo_sale_orders.states.${state}`)
                },
              },
              template:`
                <status-badge
                    v-if="translatedState != '-'"
                    entity="odoo_sale_order"
                    type="status"
                    :status="item.odoo_sale_order.state"
                ></status-badge>
                <span v-else>-</span>
              `
            },
          },
        ]
      };
    }
  },
  methods: {
    fetchModels(page = 1) {
      return this.$axios
          .get("/sale_orders", {
            params: {
              page: page,
              per_page: this.perPage,
              search: this.search,
              sort: `${this.sortBy},${this.sortDesc ? "desc" : "asc"}`,
              with: [
                "customer",
                "odoo_sale_order",
                "ticket",
                "trip"
              ].join(","),
              [this.parentFilterKey]: [this.parent.id || this.$route.params.key],
              ...this.filterParams
            }
          })
          .then(response => {
            const {
              data: { data, meta }
            } = response;
            this.models = data.map(datum => ({
              ...datum,
              _denyShow: false,
              _denyEdit: true,
              _denyDelete: true
            }));
            this.page = Number(meta.current_page);
            this.perPage = Number(meta.per_page);
            this.from = Number(meta.from);
            this.total = Number(meta.total);

            this.stats = [];

            return response;
          })
          .catch(error => {
            this.failedAlert(error);
            return null;
          });
    }
  }
};
</script>
